import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { AamsGameDataSelector, AamsGameDataState, MoneyTypes } from "@obg/gaming.aams-game-data";
import { Game } from "@obg/gaming.external";
import { CORE_ROUTE } from "@obg/ngx.core";
import { fromMinutesToMilliseconds, ignoreNil } from "@obg/ngx.global";
import { RouteAction } from "@obg/ngx.router";
import { lightFormat } from "date-fns";
import { Observable, timer } from "rxjs";
import { map } from "rxjs/operators";

import { MONEY_TYPE_TRANSLATION_KEYS } from "./aams-session-info-bar.const";

@Component({
	selector: "obg-aams-session-info-bar",
	templateUrl: "./aams-session-info-bar.container.html",
	styleUrls: ["./aams-session-info-bar.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class AamsSessionInfoBarContainer implements OnInit {
	@HostBinding("class.obg-aams-session-info-bar") hostCssClass = true;

	@Input() game: Game | undefined;
	@Input() gameHistoryEnabled = false;

	sessionTime$: Observable<string | undefined> | undefined;
	moneyTypeKey$: Observable<string> | undefined;

	constructor(
		private store: Store<AamsGameDataState>,
		private aamsGameDataSelector: AamsGameDataSelector
	) {}

	ngOnInit() {
		this.sessionTime$ = timer(0, fromMinutesToMilliseconds(1)).pipe(
			map((minutes) => lightFormat(new Date(0, 0, 0, 0, minutes), "HH:mm"))
		);

		this.moneyTypeKey$ = this.store.pipe(
			select(this.aamsGameDataSelector.getAamsMoneyType()),
			ignoreNil(),
			map((moneyType) => {
				if (moneyType === MoneyTypes.RealBonus) {
					return MONEY_TYPE_TRANSLATION_KEYS.realBonus;
				}
				if (moneyType === MoneyTypes.FunBonus) {
					return MONEY_TYPE_TRANSLATION_KEYS.funBonus;
				}
				return MONEY_TYPE_TRANSLATION_KEYS.realMoney;
			})
		);
	}

	onShowGameHistory() {
		this.store.dispatch(RouteAction.setAdditionalData({ id: this.game?.id, provider: this.game?.provider }));
		this.store.dispatch(RouteAction.navigate(CORE_ROUTE.gameRoundHistory));
	}
}
